import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';
import { CadastroPadraoComponent } from '../../shared/cadastro-padrao/cadastro-padrao.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../services/message.service';
import { StorageFunctions } from '../../general/storage';
import { UtilFunctions } from '../../general/utils-service';
import { ClientesService } from '../../services/clientes.service';
import { ItensService } from '../../services/itens.service';
import { UnidadesEmpresaService } from '../../services/unidades-empresa.service';
import { TipoItensService } from '../../services/tipo-itens.service';
import { Location } from '@angular/common';
import swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import { TipoDestaqueICMS } from '../../model/TipoDestaqueICMS';
import { ModoVenda } from '../../model/ModoVenda';
import { ConsultaAutomacaoImpostosViewModel } from 'models/itens/ConsultaItensViewModel';
declare var $;

@Component({
  selector: 'app-valida-automacao',
  templateUrl: './valida-automacao.component.html',
  styleUrls: ['./valida-automacao.component.css']
})
export class ValidaAutomacaoComponent extends CadastroPadraoComponent implements OnInit {

  @Output() formFinished = new EventEmitter<object>();
  @Input() itens = [];
  @Input() clienteId = null;
  @Input() header = 'Validar Faturamento';
  @Input() clienteFinal: boolean;
  @Input() cfopContribuinte: boolean;
  @Input() tipoNFeID: number;
  @Input() modoVenda: ModoVenda;
  @Input() presencaComprador: number;
  private pagina = 0;
  itemsConsulta = [];
  tipoItens: any[];
  unidadeEmpresa: any;
  cliente: any;
  private clienteInit: any;
  private consultandoItem = 0;

  tipoDestaqueICMS = TipoDestaqueICMS.Listar();

  constructor(route: ActivatedRoute,
    message: MessageService,
    storage: StorageFunctions,
    location: Location,
    utilFunctions: UtilFunctions,
    private clientesService: ClientesService,
    private elementRef: ElementRef,
    private itensService: ItensService,
    private unidadesEmpresaService: UnidadesEmpresaService,
    private tiposItensService: TipoItensService) {
    super(route, utilFunctions, message, storage, location);
    this.cancelaVerificacaoPermissao = true;
  }

  private carregaTipoItens() {
    return new Promise((resolve, reject) => {
      this.tiposItensService.get()
        .pipe(finalize(() => resolve({})))
        .subscribe(result => {
          this.tipoItens = result;
        });
    });
  }

  private carregaCliente() {
    return new Promise((resolve, reject) => {
      this.clientesService.getClienteById(this.clienteId)
        .pipe(finalize(() => resolve({})))
        .subscribe(res => {
          this.clienteInit = Object.assign({}, res);
          this.cliente = Object.assign({}, res);
          this.cliente.clienteFinal = this.clienteFinal;
        });
    });
  }

  private carregaEmpresa() {
    return new Promise((resolve, reject) => {
      this.unidadesEmpresaService.getUnidadeEmpresa()
        .pipe(finalize(() => resolve({})))
        .subscribe(res => {
          this.unidadeEmpresa = res;
        });
    });
  }

  ngOnInit() {
    this.loading['dadosGerais'] = true;
    Promise.all([this.carregaTipoItens(), this.carregaCliente(), this.carregaEmpresa()])
      .then(() => {
        this.loading['dadosGerais'] = false;
        this.getInfoItens();
      });
  }

  @HostListener('scroll', ['$event'])
  scrollHandler(event) {
    if (event && event['target']) {
      const scrollTop = event['target'].scrollTop;
      const height = event['target'].clientHeight;
      const scrollHeight = event['target'].scrollHeight;

      if (scrollTop + height >= scrollHeight) {
        if (!this.loading['dadosItem'] && this.itemsConsulta.length < this.itens.length) {
          this.getInfoItens();
        }
      }
    }
  }

  getCRT(crt) {
    switch (crt) {
      case 1:
        return 'Simples Nacional';
      case 2:
        return 'Simples Nacional - excesso de sublimite de receita bruta';
      case 3:
        return 'Normal';
      case 4:
        return 'MEI';
    }
  }

  getInfoItens() {
    this.loading['dadosItem'] = true;
    let consulta = this.itens.slice(this.pagina * 10, (this.pagina * 10) + 10);
    consulta = consulta.map(x => {
      return {
        ItemID: x.produto,
        CodigoFiscalID: x.codigoFiscalID || null,
        bonificacaoOuBrinde: x.bonificacaoOuBrinde,
      };
    });

    const param = {
      Cliente: this.cliente,
      TipoNFeID: this.tipoNFeID,
      Produtos: consulta,
      modoVenda: this.modoVenda,
      presencaComprador: this.presencaComprador,
      cfopContribuinte: this.cfopContribuinte,
    };

    this.itensService.obterDadosValidacao(param)
      .pipe(finalize(() => this.loading['dadosItem'] = false))
      .subscribe(res => {
        if (res.length > 0) {
          this.pagina++;
        }

        res.forEach(element => {
          const newItem = {
            produto: Object.assign({}, element.produto),
            automacao: element.automacao,
            produtoInit: Object.assign({}, element.produto),
            bonificacaoOuBrinde: element.bonificacaoOuBrinde,
          };

          this.itemsConsulta.push(newItem);
        });

        if (this.itemsConsulta.length <= 10) {
          setTimeout(() => {
            this.elementRef.nativeElement.querySelector('#divTabe').scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 10);
        }
      });
  }

  getTypeItem(typeItemID) {
    let response = '';

    if (typeItemID) {
      response = this.tipoItens.find(element => element.id === typeItemID).descricao;
    }

    return response;
  }

  getValueRedIcms(value) {
    if (value > 0) { return 'Sim'; }
    return 'Não';
  }

  alterouParametroItem(event, indexItem, type = null) {
    if (type === 'tipoDestaqueICMS' && event?.value !== 0) {
      this.itemsConsulta[indexItem].produto.substituicaoTributaria = false;
    } else if (type === 'sujeitoST' && event.target.checked) {
      this.itemsConsulta[indexItem].produto.tipoDestaqueICMS = TipoDestaqueICMS.NORMAL;
    }

    this.consultaAutomacaoImpostos(indexItem);
  }

  consultaAutomacaoImpostos(index: number) {
    const consulta: ConsultaAutomacaoImpostosViewModel = {
      clienteID: this.cliente.id,
      clienteFinal: this.cliente.clienteFinal,
      cfopContribuinte: this.cfopContribuinte,
      clienteSimples: this.cliente.simples,
      itemID: this.itemsConsulta[index].produto.id,
      tipoItemId: this.itemsConsulta[index].produto.tipoItemid,
      substituicaoTributaria: this.itemsConsulta[index].produto.substituicaoTributaria,
      tipoDestaqueICMS: this.itemsConsulta[index].produto.tipoDestaqueICMS,
      bonificacaoOuBrinde: this.itemsConsulta[index].bonificacaoOuBrinde,
      modoVenda: this.modoVenda,
      tipoNFeID: this.tipoNFeID,
      presencaComprador: this.presencaComprador,
    };

    this.itemsConsulta[index].consultando = true;
    this.loading['dadosItem'] = true;
    this.consultandoItem++;
    this.itensService.consultaAutomacaoImpostos(consulta)
      .pipe(finalize(() => {
        this.itemsConsulta[index].consultando = false;
        this.loading['dadosItem'] = false;
        this.consultandoItem--;
      }))
      .subscribe(res => {
        this.itemsConsulta[index].automacao = res;
      }, () => {
        this.itemsConsulta[index].automacao = null;
      });
  }

  verificaAutomacao(indexItem) {
    if (!this.itemsConsulta[indexItem].automacao) { return 'red'; }
    return '';
  }

  verificaDentroEstado() {
    if (this.cliente.cidade.estado.id === this.unidadeEmpresa.cidade.estado.id) {
      return true;
    }
    return false;
  }

  alteraDadoCliente() {
    this.itemsConsulta.forEach(async (element, index) => {
      this.consultaAutomacaoImpostos(index);
    });
  }

  salvar(emitirNfe = false) {
    if (!this.verificaBloqueio()) {

      const listPromisses = [];
      this.loading['salvando'] = true;

      if (this.clienteInit.simples !== this.cliente.simples
        || this.clienteInit.clienteFinal !== this.cliente.clienteFinal) {

        const clientePromisse = new Promise((resolve, reject) => {
          this.clientesService.updateCliente(this.cliente)
            .pipe(finalize(() => resolve({})))
            .subscribe(() => {
              // Cliente Atualizado
            }, () => {
              reject('Erro ao salvar alterações no cliente!');
            });
        });

        listPromisses.push(clientePromisse);
      }

      this.itemsConsulta.forEach((element, index) => {
        if (element.produtoInit.tipoItemid !== element.produto.tipoItemid
          || element.produtoInit.substituicaoTributaria !== element.produto.substituicaoTributaria
          || element.produtoInit.tipoDestaqueICMS !== element.produto.tipoDestaqueICMS) {
          const itemPromisse = new Promise((resolve, reject) => {
            this.itensService.update(element.produto)
              .pipe(finalize(() => resolve({})))
              .subscribe(() => {
                // Item Atualizado
              }, () => {
                reject('Erro ao salvar alterações no item: ' + element.produto.nome);
              });
          });

          listPromisses.push(itemPromisse);
        }

        if (this.itens[index]) {
          this.itens[index].bonificacaoOuBrinde = element.bonificacaoOuBrinde;
        }
      });

      Promise.all(listPromisses).then(() => {
        const clienteFinal = this.cliente.clienteFinal;
        const cfopContribuinte = this.cfopContribuinte;
        this.loading['salvando'] = false;

        if (!emitirNfe) {
          swal('Sucesso', 'Alterações salvas com sucesso!', 'success');
        }

        this.formFinished.emit({ emitirNfe, clienteFinal, cfopContribuinte });

      }).catch(err => {
        swal('Erro', err, 'error');
      });

    } else {
      swal('Erro', 'Espere todas as consultas acabarem!', 'error');
    }
  }

  fechar() {
    this.formFinished.emit();
  }

  verificaBloqueio() {
    if (this.consultandoItem > 0 || this.loading['dadosItem'] || this.loading['salvando']) {
      return true;
    }

    return false;
  }

  getTipoVenda() {
    return ModoVenda.getDescricao(this.modoVenda);
  }
}
